// import ApplicantCertifcatesTab from "./applicant-certificates";
import SectionCanChat from "../../../../candidate/sections/chat/section-can-chat";
import SectionApplicantCoverLetter from "../../common/section-applicant-cover-letter";
import ApplicantDocumentsTab from "./applicant-document";
import ApplicantNotesTab from "./applicant-notes";

function SectionTabContent({ applicantDetailsId, applicantDetailInfo, coverLetterText, activeTab }) {
  const isNotEmployee = applicantDetailInfo?.workerType && applicantDetailInfo?.workerType !== "Employee";

  return (
    <div className="tab-content" id="myTab2">
      <div className={`tab-pane fade ${isNotEmployee ? 'show active' : ''}`} id="applicant-document">
        <ApplicantDocumentsTab
          key="1"
          applicantDetailsId={applicantDetailsId}
          applicantDetailInfo={applicantDetailInfo}
          tabType={"document"}
          activeTab={activeTab}
        />
      </div>
      <div className="tab-pane fade" id="applicant-certificates">
        <ApplicantDocumentsTab
          key="2"
          applicantDetailsId={applicantDetailsId}
          applicantDetailInfo={applicantDetailInfo}
          tabType={"certificate"}
          activeTab={activeTab}
        />
      </div>
      {/* <div className="tab-pane fade" id="applicant-notes">
        <ApplicantNotesTab applicantDetailsId={applicantDetailsId} />
      </div> */}
      <div className={`tab-pane fade ${isNotEmployee ? '' : 'show active'}`} id="applicant-resume-cover-letter">
        {/* <ApplicantNotesTab applicantDetailsId={applicantDetailsId} /> */}
        <SectionApplicantCoverLetter applicantDetailInfo={applicantDetailInfo} coverLetterText={coverLetterText} />
      </div>
      <div className="tab-pane fade" id="applicant-chat">
        <div className="twm-right-section-panel site-bg-gray">
          <div className="wt-admin-dashboard-msg-2  twm-dashboard-style-2">
            <SectionCanChat jobId={applicantDetailInfo?.userEntityId} jobItem={applicantDetailInfo} forApplied={false} isGroup={true} userRoleType={"ROLE_USER"}/>
          </div>
        </div>
      </div>
      {console.log("applicantDetailInfo?.userEntityId",applicantDetailInfo?.userEntityId)}
    </div>
  );
}

export default SectionTabContent;
